export class VerifyBeneficiary {
    uniqueLink: string
    medicareNumber: string
    lastName: string
    dateofBirth: string
}